export const KINSHIPS_ACTIONS = {
    GET: 'GET_KINSHIPS',
    GET_LIST: 'GET_LIST_KINSHIPS',
    FIND: 'FIND_KINSHIPS',
    CHANGE_STATUS: 'CHANGE_STATUS_KINSHIPS',
    SUCCESS: 'SUCCESS_KINSHIPS',
    ERROR: 'ERROR_KINSHIPS',
    CLEAN: 'CLEAN_KINSHIPS',
}